import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  private api = inject(VwApiRequestsService);

  list() {
    return this.api.getAPICall('/users');
  }

  create(payload: { name: string; username: string; password: string; role: string; language?: string; assignments?: any[] }) {
    return this.api.postAPICall('/users', payload);
  }

  update(id: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/users/${id}`, payload);
  }

  changeOwnPassword(currentPassword: string, newPassword: string) {
    return this.api.postAPICall('/users/me/change-password', { currentPassword, newPassword });
  }
}
